module.exports = __webpack_public_path__ + "img/micrec.c9b814aa.jpeg";